import { render, staticRenderFns } from "./storeGood.vue?vue&type=template&id=14a00503&scoped=true"
import script from "./storeGood.vue?vue&type=script&lang=js"
export * from "./storeGood.vue?vue&type=script&lang=js"
import style0 from "./storeGood.vue?vue&type=style&index=0&id=14a00503&prod&lang=less&scoped=true"
import style1 from "./storeGood.vue?vue&type=style&index=1&id=14a00503&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a00503",
  null
  
)

export default component.exports